import {
  AfterViewChecked,
  Component,
  ContentChildren,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  EventEmitter,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {AchooTabComponent} from './achoo-tab/achoo-tab.component';
import {TabInkBarDirective} from './tab-ink-bar.directive';
import {TabLabelWrapperDirective} from './tab-label-wrapper.directive';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'achoo-tabs',
  templateUrl: './achoo-tabs.component.html',
  styleUrls: ['./achoo-tabs.component.scss'],
})
export class AchooTabsComponent implements AfterViewChecked {
  @ContentChildren(AchooTabComponent) tabs: QueryList<AchooTabComponent>;
  @ViewChildren(TabLabelWrapperDirective) labelWrappers: QueryList<TabLabelWrapperDirective>;
  @ViewChild(TabInkBarDirective) inkBar: TabInkBarDirective;

  @Input() set selectedTabKey(value: string) {
    this.currentSelectedTabId = value;
    if (!this.tabs) {
      return;
    }

    this.selectTab(this.getSelectedTab(), true);
  }
  @Output()
  public tabClicked: EventEmitter<any> = new EventEmitter<any>();

  get selectedTabKey(): string {
    return this.currentSelectedTabId;
  }

  debouncer = new Subject<AchooTabComponent>();
  currentSelectedTabId: string;

  constructor() {
    this.debouncer.debounceTime(100)
      .subscribe(tab => {
        this.alignInkBar();
      });
  }

  ngAfterViewChecked() {
    if (!this.tabs) {
      return;
    }

    this.tabs.forEach(x => x.changed.subscribe(tab => {
      this.debouncer.next(tab);
    }));

    const activeTabs = this.tabs.filter(x => x.active);
    if (activeTabs.length === 0) {
      this.selectTab(this.getSelectedTab(), true);
    }
  }

  getSelectedTab(): AchooTabComponent {
    if (!this.tabs) {
      return null;
    }

    return this.tabs.find(x => x.tabKey === this.selectedTabKey) || this.tabs.first;
  }

  selectTab(tab: AchooTabComponent, isCheckComponentView: boolean) {
    const activeTab = tab || this.getSelectedTab();

    if (!activeTab) {
      return;
    }

    // Emit selected tab to parent component
    if (!isCheckComponentView) {
      this.tabClicked.emit(activeTab.tabKey);
    }

    const doActivateSelectedTab = () => {
      // Deactive all tabs
      this.tabs.toArray().forEach(x => x.active = false);

      this.currentSelectedTabId = activeTab.tabKey;
      // Active selected tab
      activeTab.active = true;

      // Update ink-bar to current selected tab
      this.alignInkBar();
    };


    // Update follow-bar
    // Reference URL: http://blog.teamtreehouse.com/efficient-animations-with-requestanimationframe
    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(() => doActivateSelectedTab());
    } else {
      // This will run out of main thread and make the UI update smoothly
      setTimeout(() => doActivateSelectedTab(), 0);
    }
  }

  delayUpdate() {
    this.debouncer.next(null);
  }

  private alignInkBar(): void {
    const selectedTab = this.getSelectedTab(),
      tabIndex = this.tabs.toArray().indexOf(selectedTab);
    const selectedLabelWrapper = this.labelWrappers && this.labelWrappers.length
      ? this.labelWrappers.toArray()[tabIndex].elementRef.nativeElement
      : null;
    if (!selectedLabelWrapper) {
      this.inkBar.hide();
      return;
    }
    this.inkBar.alignToElement(selectedLabelWrapper);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/achoo-tabs.component.ts